module.exports = __webpack_public_path__ + "static/Mobile-5f1c9ace1335286b7632a4f6a3ee19d2.svg";